import { TFunction } from 'i18next'

import { EInvoiceAddressSchemeType } from '../../../../../enums/eInvoiceAddressSchemeType'
import { EntityType } from '../../../../../enums/entityType'
import { EInvoiceScheme } from '../../../../../types/eInvoiceScheme'

type GetEInvoiceAddressLabelOptions = {
  countryId?: string
  entityType?: EntityType
  schemeType: EInvoiceScheme
  t: TFunction
}

export const getEInvoiceAddressLabel = ({
  countryId,
  entityType,
  schemeType,
  t,
}: GetEInvoiceAddressLabelOptions): string => {
  if (schemeType === EInvoiceAddressSchemeType.LWID) {
    return t('customer_modal.form.e_invoice_address.LWID.label')
  } else if (schemeType === EInvoiceAddressSchemeType.SIRENE || countryId === 'FR') {
    const isPublicEntity = entityType === EntityType.Public

    return isPublicEntity
      ? t('customer_modal.form.e_invoice_address.SIRET.label')
      : t('customer_modal.form.e_invoice_address.SIRENE.label')
  }

  return t('customer_modal.form.e_invoice_address.label')
}
